import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Trash2 } from "lucide-react";
import { DESTINOS } from "@/components/EditableNote";

const destLabel = (k) => DESTINOS.find((d) => d.key === (k || "todos"))?.label;

const NotaRow = ({ orderId, nota, onSaved }) => {
  const [texto, setTexto] = useState(nota.texto || "");
  const [destino, setDestino] = useState(nota.destino || "todos");
  const [busy, setBusy] = useState(false);
  const run = async (fn, msg) => {
    setBusy(true);
    try { const { data } = await fn(); toast.success(msg); onSaved(data); } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  const cambiado = texto.trim() !== (nota.texto || "") || destino !== (nota.destino || "todos");
  return (
    <div className="border border-zinc-200 rounded p-2 space-y-1" data-testid={`nota-row-${nota.id}`}>
      <div className="text-[10px] text-zinc-500">{nota.nombre || "Nota anterior"}{nota.at ? ` · ${new Date(nota.at).toLocaleString("es-GT", { timeZone: "America/Guatemala" })}` : ""} · {destLabel(nota.destino)}</div>
      <textarea value={texto} onChange={(e) => setTexto(e.target.value)} rows={2} disabled={busy}
        className="w-full text-xs rounded border border-zinc-300 p-1.5" data-testid={`nota-texto-${nota.id}`} />
      <div className="flex items-center gap-2">
        <select value={destino} onChange={(e) => setDestino(e.target.value)} disabled={busy}
          className="text-xs rounded border border-zinc-300 p-1" data-testid={`nota-destino-${nota.id}`}>
          {DESTINOS.map((d) => <option key={d.key} value={d.key}>{d.label}</option>)}
        </select>
        <button disabled={busy || !cambiado || !texto.trim()} className="text-xs font-semibold text-white bg-[#002FA7] disabled:opacity-40 rounded px-2 py-1"
          onClick={() => run(() => api.put(`/orders/${orderId}/notas-hoja/${nota.id}`, { texto: texto.trim(), destino }), "Nota actualizada")}
          data-testid={`nota-guardar-${nota.id}`}>Guardar</button>
        <button disabled={busy} className="ml-auto text-xs text-red-600 inline-flex items-center gap-1"
          onClick={() => window.confirm("¿Eliminar esta nota?") && run(() => api.delete(`/orders/${orderId}/notas-hoja/${nota.id}`), "Nota eliminada")}
          data-testid={`nota-eliminar-${nota.id}`}><Trash2 className="w-3 h-3" /> Eliminar</button>
      </div>
    </div>
  );
};

export const NotasManager = ({ orderId, modulo, onClose, onSaved }) => {
  const [notas, setNotas] = useState(null);
  const load = async () => {
    try { const { data } = await api.get(`/orders/${orderId}/notas-hoja`, { params: { modulo: modulo === "notas_hoja" ? "hoja" : modulo } }); setNotas(data || []); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  useEffect(() => { load(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderId]);
  const saved = (data) => { onSaved(data); load(); };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg max-h-[85vh] overflow-y-auto" data-testid={`notas-manager-${orderId}`}>
        <DialogHeader><DialogTitle>Editar notas</DialogTitle></DialogHeader>
        {notas === null ? <div className="text-sm text-zinc-500">Cargando…</div>
          : notas.length === 0 ? <div className="text-sm text-zinc-500">Sin notas.</div>
          : <div className="space-y-2">{notas.map((n) => <NotaRow key={`${n.id}-${n.texto}-${n.destino}`} orderId={orderId} nota={n} onSaved={saved} />)}</div>}
      </DialogContent>
    </Dialog>
  );
};
